import { APP_BASE_HREF } from '@angular/common';
import {
  Component,
  effect,
  inject,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

import { TellentNavigationRoutingService } from '@core/tellent-logic';
import { TellentWebComponent } from '@core/tellent-types';
import { DialogOutletDirective } from '@core/user-interface-routing-logic';

@Component({
  selector: 'x-router-outlet',
  template: `
    <router-outlet />
    <dialog-outlet name="dialog" />
  `,
  imports: [RouterOutlet, DialogOutletDirective],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../../../styles.less', './router-outlet.component.less'],
})
export class TellentRouterOutlet {
  private readonly router = inject(Router);
  private readonly routingService = inject(TellentNavigationRoutingService);
  private readonly baseHref = inject(APP_BASE_HREF);

  private readonly watchLocationChange = effect(() => {
    const location = this.routingService.location();
    if (!location) return;

    const normalizedLocation = location.startsWith(this.baseHref)
      ? location.replace(this.baseHref, '')
      : location;
    this.router.navigateByUrl(normalizedLocation);
  });

  constructor() {
    this.router.initialNavigation();
  }
}

export type TellentRouterOutletWebComponent = TellentWebComponent<TellentRouterOutlet, never>;
